module.exports = __webpack_public_path__ + "static/media/braille.c555e12e.svg";